import * as $ from 'jquery';
import LoadingAnimationHelper from './Helper/LoadingAnimationHelper';
import EqualHeightGridController from './EqualHeightGridController';

/**
 * BlogController
 *
 * @author Felix König <f.koenig@andersundsehr.com>
 */
export default class BlogController {
  private $blogContainer = $('.js-blogContainer');

  /**
   * Public function to init class
   */
  constructor() {
    this.showNews($('.js-ajaxItem'));
    $(document).on('click', '.blog__list .f3-widget-paginator li.next a', (event) => {
      const loadingAnimationHelper = new LoadingAnimationHelper();
      loadingAnimationHelper.appendLoadingAnimation(this.$blogContainer.parent());
      const link = $(event.target).attr('href');
      $(event.target).parent().parent().remove();
      this.getNextTestimonials(link);
      return false;
    });

    if (document.querySelector('.js-blog__tilesScroll')) {
      window.setTimeout(
        () => {
          this.blogSliderWidth();
        },
        200,
      );

      window.addEventListener('resize', () => {
        this.blogSliderWidth();
      });
    }
  }

  /**
   * Start ajax request
   * @param link
   */
  getNextTestimonials(link) {
    $.ajax({
      type: 'GET',
      url: link,
      success: (result) => {
        const $result = $(result);
        const $html = $result.find('.js-ajaxItem');
        $html.addClass('js-hide');
        this.$blogContainer.append($html);
        this.$blogContainer.append($result.find('.f3-widget-paginator'));
        this.showNews($html);
      },
    }).always(() => {
      const loadingAnimationHelper = new LoadingAnimationHelper();
      loadingAnimationHelper.removeLoadingAnimation(this.$blogContainer.parent());
    });
  }

  showNews($news) {
    $news.each((index, elem) => {
      const $this = $(elem);
      if ($this.hasClass('js-hide')) {
        $this.show(() => {
          const equalHeightGridController = new EqualHeightGridController();
          equalHeightGridController.update();
        });
        $this.removeClass('js-hide');
      }
    });
  }

  blogSliderWidth() {
    const BlogElement = document.querySelector<HTMLElement>('.js-blog__tilesScrollWidth .blog__tile');
    const BlogTotalElements = document.querySelectorAll('.js-blog__tilesScrollWidth .blog__tile').length;
    const BlogElementWrap = document.querySelector<HTMLElement>('.js-blogContainer')!;

    if (BlogElement !== null) {
      const BlogElementWidth = BlogElement.offsetWidth;
      const BlogElementsPerRow = Math.ceil(BlogTotalElements / 2);
      const BlogElementTotalWidth = (BlogElementWidth + 40) * BlogElementsPerRow;
      BlogElementWrap.style.width = BlogElementTotalWidth + 'px';

      if (window.matchMedia('(max-width: 1024px)').matches) {
        BlogElementWrap.style.width = 'auto';
      }
    }
  }
}
